import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import AiOverview from './AiOverview.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'ai_overview_reports', params: to.params };
          },
        },
        {
          path: 'ai-overview',
          name: 'ai_overview_reports',
          meta,
          component: AiOverview,
        },
      ],
    },
  ],
};
